import React, {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useLocation } from "react-router";
import Loader from 'react-loader-spinner';
// Icon-based pagination like QueryResultInternational
import pageLeft from "../../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../../assets/images/CounselorCurrent/Page/center.png";
import QueryService from "../../../services/QueryService";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../customLoader/CustomLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import swal from "sweetalert";
// Reuse the same styles as QueryResultInternational for table, footer buttons, and pagination
import "../../queryresult/QueryResult.css";

const MyStudentList = () => {

  let history = useHistory();
  let location = useLocation();
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState(0);
  const [paginationCount, setPaginationCount] = useState();
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [loaderForExport, setLoaderForExport] = useState(false);
  const [selectedRowFromResultTable, setSelectedRowFromResultTable] = useState([])
  // const prevSelectionModel = React.useRef(selectedRowFromResultTable);
  // const prevSelectionModelData = React.useRef(saveSelection);
  const [saveSelection, setSaveSelection] = useState([])
  const [queryStudentData, setQueryStudentData] = useState();
  const [newSelectedIds, setNewSelectedIds] = useState([]);
  const [filteredSaveSelection, setFilteredSaveSelection] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [from, setFrom] = useState(location?.state?.fromSavedQueriedResult);


  let userData = useSelector((state) => state.UserReducer.userObj);

  const [sortModel, setSortModel] = useState([]);

  const fieldMap = {
    '0': 'email',
    '1': 'first_name',
    '2': 'last_name',
    '3': 'ethnicity',
    '4': 'gender',
    '5': 'gpa',
    '6': 'grade',
    '7': 'school_name',
  };

  const getFavStudentData = () => {
    setLoading(true);
    // const body = {
    //   "college_id": userData.college,
    //   "recruiter_id": userData.id,
    //   "role" : userData.role
    // }
    const firstSort = Array.isArray(sortModel) && sortModel.length > 0 ? sortModel[0] : null;
    // Build query params for server-side sort & pagination similar to QueryResultInternational
    const params = {
      page,
      ...(firstSort
        ? {
            field: fieldMap[firstSort.field] || firstSort.field,
            direction: firstSort.sort === 'asc' ? 'asc' : 'desc',
          }
        : {}),
    };

    QueryService.getFavoritePage(params)
      .then(async (data) => {
        console.log("data",data.data);
        setQueryStudentData(data.data);
        const newArrayOfObj = data.data.student_list.map(
          ({ 8: id, ...rest }) => ({
            id,
            ...rest,
          })
        );
        console.log("newArray",newArrayOfObj);
        setTableData(newArrayOfObj);
        setPaginationCount(data.data.total_pages);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error from the service", error);
      });
  };

  useEffect(()=>{
    getFavStudentData();
  },[sortModel, page])

  const columns = [
    {
      field: "0",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 300,
      resizable: true,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#1e40af", fontWeight: 500 }}>
          <span style={{ backgroundColor: "#eff6ff", padding: "4px 8px", borderRadius: "6px", fontSize: "12px" }}>
            {params.value || "No email"}
          </span>
        </div>
      ),
    },
    {
      field: "1",
      headerName: "First name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      renderCell: (params) => (
        <div style={{ fontWeight: 600, color: "#059669", fontSize: "14px" }}>
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "2",
      headerName: "Last name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      renderCell: (params) => (
        <div style={{ fontWeight: 600, color: "#059669", fontSize: "14px" }}>
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "3",
      headerName: "Ethnicity",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <span style={{ backgroundColor: "#eef2ff", color: "#4338ca", padding: "4px 8px", borderRadius: "10px", fontSize: "12px", fontWeight: 600 }}>
          {params.value || "N/A"}
        </span>
      ),
    },
    {
      field: "4",
      headerName: "Gender",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor:
              params.value === "Male"
                ? "#fef3f2"
                : params.value === "Female"
                ? "#f0f9ff"
                : "#f9fafb",
            color:
              params.value === "Male"
                ? "#dc2626"
                : params.value === "Female"
                ? "#2563eb"
                : "#6b7280",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {params.value || "Not specified"}
        </div>
      ),
    },
    {
      field: "5",
      headerName: "Overall GPA",
      headerClassName: "super-app-theme--header",
      type: "number",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const val = parseFloat(params.value);
        const bg = isNaN(val)
          ? "#f9fafb"
          : val >= 3.5
          ? "#f0fdf4"
          : val >= 3.0
          ? "#fffbeb"
          : val >= 2.5
          ? "#fef2f2"
          : "#f9fafb";
        const color = isNaN(val)
          ? "#6b7280"
          : val >= 3.5
          ? "#059669"
          : val >= 3.0
          ? "#d97706"
          : val >= 2.5
          ? "#dc2626"
          : "#6b7280";
        return (
          <div
            style={{
              backgroundColor: bg,
              color,
              padding: "6px 10px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {isNaN(val) ? "N/A" : val.toFixed(2)}
          </div>
        );
      },
    },
    {
      field: "6",
      headerName: "Grade",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <span style={{ backgroundColor: "#f9fafb", color: "#374151", padding: "4px 8px", borderRadius: "12px", fontSize: "12px", border: "1px solid #e5e7eb", fontWeight: 600 }}>
          {params.value || "-"}
        </span>
      ),
    },
    {
      field: "7",
      headerName: "School Name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 400,
      flex: 1,
      renderCell: (params) => (
        <div style={{ fontSize: "13px", color: "#374151", fontWeight: 500, display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ backgroundColor: "#f9fafb", padding: "4px 8px", borderRadius: "6px", border: "1px solid #e5e7eb" }}>
            {params.value || "No school specified"}
          </span>
        </div>
      ),
    },
  ];

  const handleCellClick = (cell) => {
    // console.log("yy",cell);
    let cel = cell.row;
    if (saveSelection && Array.isArray(saveSelection)) {
      console.log("inside if");
      let filteredValue = saveSelection.includes(cel);
      console.log("save selection", saveSelection);
      if (filteredValue === true) {
        let index = saveSelection.indexOf(cel);
        saveSelection.splice(index, 1);
        setSaveSelection(saveSelection);
        return;
      }
    } else if (
      saveSelection === "selected All" &&
      typeof saveSelection === "string"
    ) {
      const selectedRows = tableData.filter((item) =>
        selectedRowFromResultTable.includes(item.id)
      );
      let filteredValue = selectedRows.includes(cel);
      if (filteredValue === true) {
        let index = selectedRows.indexOf(cel);
        selectedRows.splice(index, 1);
        setSaveSelection(selectedRows);
        return;
      }
    }
  };

  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
}

const deleteTranscript = () => {
  let payload;
    let n2 = {};
    let n1 = newSelectedIds.map((i, index) => {
      n2[index] = { school_id: i["9"], student_id: i["10"] };
    });
      if (saveSelection === "selected All") {
        payload = {
          is_all: true,
          // recruiter_id: userData.id,
          // college_id: n2.school_id,
        };
      } else {
        payload = {
          is_all: false,
          details: n2,
          // recruiter_id: userData.id,
      } }

  QueryService.deleteTrans(payload)
  .then((data) => {
    console.log("data from the service", data);
    swal({
      text: `Students Deleted Successfully from My Student List.`,
      icon: "success",
      buttons: {
        OK: true,
      },
      closeOnClickOutside: false,
    }).then((value) => {
      if (value === "OK") {
        window.location.reload();
      }
    });
  })
  .catch((error) => {
    console.log("error from save student service", error);
  })}

const downloadTranscript = () => {
    setLoaderForExport(true);
    let payload;
    let n2 = {};
    let n1 = newSelectedIds.map((i, index) => {
      n2[index] = { school_id: i["9"], student_id: i["10"] };
    });
      if (saveSelection === "selected All") {
        payload = {
          is_all: true,
          // recruiter_id: userData.id,
        };
      } else {
        payload = {
          is_all: false,
          details: n2,
          // recruiter_id: userData.id,
      } }
    QueryService.downloadTrans(payload)
      .then((data) => {
        console.log("data from the service", data);
        downloadFile(data.data.download, "My File")
        setLoaderForExport(false);
        // setLoaderForSave(false);
        // swal({
        //     text: `Student Data Saved Successfully to My Student List.`,
        //     icon: "success",
        //     buttons: {
        //       OK: true,
        //     },
        //     closeOnClickOutside: false,
        //   }).then((value) => {
        //     if (value === "OK") {
        //       history.push('/recruiter/campaign')
        //     }
        //   });
      })
      .catch((error) => {
        console.log("error from save student service", error);
        setLoaderForExport(false);
        // setLoaderForSave(false);
        // if (error.response.status == 409) {
        //   swal({
        //     text: error?.response?.data?.message,
        //     icon: "warning",
        //     dangerMode: true,
        //     buttons: {
        //       cancel: true,
        //     },
        //     closeOnClickOutside: false,
        //   });
        // }
        })
}

  const onExportClick = () => {
    const hasSelection =
      saveSelection === "selected All" ||
      (Array.isArray(saveSelection) && saveSelection.length > 0);
    if (!hasSelection) {
      swal({
        text: "Please select at least one record to export.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          OK: true,
        },
        closeOnClickOutside: false,
      });
      return;
    }
    downloadTranscript();
  };


  const onSelection = (ids) => {
    console.log("getting clled");
    if (Array.isArray(ids) && ids.length > 0) {
      setSelectedRowFromResultTable(ids);
      const selectedIDs = new Set(ids);
      let selectedRows = tableData.filter((item) => selectedIDs.has(item.id));
      setNewSelectedIds(selectedRows);
      // console.log('ids from the onSelection', ids, selectedRows, selectedRows.length)
      // let filteredValue = saveSelection.filter(item => selectedIDs.has(!item.id))
      // selectedRows = filteredValue
      if (page !== 1) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      } else if (page === 1 && selectedRows?.length === tableData.length) {
        setSelectAll(true);
        if (from) {
          setSaveSelection(selectedRows);
        } else if (!from) {
          // setShowGroupMessageAlert(true);
          setSaveSelection("selected All");
        }
      } else if (page === 1 && selectedRows?.length !== tableData.length) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      }
    } else if (Array.isArray(ids) && ids.length === 0) {
      setSaveSelection([]);
      setSelectedRowFromResultTable([]);
      setFilteredSaveSelection([]);
    }
  };


  return (
    <Fragment>
      <div>
        <div>
          <div>
            <p
              style={{ fontSize: "18px", marginBottom: "10px" }}
              className="bold"
            >
              Student Records
            </p>
            {/* <p onClick={() => {dispatch(changeQueryLocation({})); navigateToQuery()}} className="no-margin-bottom font cursor" style={{ textDecoration: 'underline', paddingLeft: '18px' }}>Create New Query Criteria</p> */}
          </div>
          {/* <div>
                                    <p style={{ color: '#333333', opacity: '0.8' }} className="no-margin-bottom bold">{`${queryResultData ? queryResultData?.num_students : from ? tableData.length : 0} Students Found`}</p>
                                </div> */}
        </div>
        {/* <div style={{ padding: '15px' }}>
                                <p style={{ color: '#333333', opacity: '0.8' }} className="bold">{`You are viewing ${tableData ? tableData?.length : 0} Student out of ${queryResultData ? queryResultData?.num_students : 0} Results`}</p>
                            </div> */}
        {loading ? (
          <CustomLoader />
        ) : (
          <div
            className={
              paginationCount && paginationCount > 1
                ? "table-container"
                : "table-container-less"
            }
            style={{
              background: '#ffffff',
              borderRadius: '16px',
              padding: '16px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
              border: '1px solid #f1f5f9',
              margin: '16px 0',
            }}
          >
            <DataGrid
              className="result-table"
              pageSize={pageSize}
              rows={tableData}
              columns={columns}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={(model) => setSortModel(model)}
              rowsPerPageOptions={[20]}
              checkboxSelection
              onSelectionModelChange={(ids) => onSelection(ids)}
              hideFooterPagination={true}
              hideFooterSelectedRowCount={false}
              rowHeight={145}
              columnHeader
              selectionModel={selectedRowFromResultTable}
              onRowClick={(row) => handleCellClick(row)}
              disableSelectionOnClick={true}
              autoPageSize={true}
              sx={{
                border: 'none',
                '& .MuiDataGrid-cell': {
                  borderColor: '#f3f4f6',
                  fontSize: '13px',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f8fafc',
                  '& .MuiDataGrid-columnHeader': {
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#374151',
                  },
                },
                '& .MuiDataGrid-row': {
                  '&:nth-of-type(even)': {
                    backgroundColor: '#fafafa',
                  },
                  '&:hover': {
                    backgroundColor: '#f3f4f6 !important',
                  },
                },
                '& .MuiDataGrid-cell:focus': {
                  outline: 'none !important',
                },
                '& .MuiDataGrid-row.Mui-selected': {
                  backgroundColor: '#e0f2fe !important',
                  '&:hover': {
                    backgroundColor: '#b3e5fc !important',
                  },
                },
                '& .MuiDataGrid-virtualScroller': {
                  '&::-webkit-scrollbar': {
                    width: '6px',
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f5f9',
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#87ceeb',
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#5fb3d4',
                  },
                }
              }}
            />
          </div>
        )}

      <div className="qr-footer-topline" />
      <div className="result-button-container">
        <button
          onClick={onExportClick}
          style={{ justifyContent: "center", background: '#1395F2', borderColor: '#1395F2', color: '#fff' }}
          className="qr-footer-btn flex"
        >
          <img src={require("../../../assets/images/premiumService/export.png")} alt="" className="btn-icon" />
          Export Transcript
          {loaderForExport && (
            <span>
              <Loader type="TailSpin" color="#E36221" height={20} width={20} />
            </span>
          )}
        </button>
        <button
          onClick={() => deleteTranscript()}
          disabled={saveSelection.length > 0 ? false : true}
          className="qr-footer-btn"
          style={{
            background: '#fff',
            color: '#FE6A07',
            borderColor: '#FE6A07',
          }}
        >
          <img src={require("../../../assets/images/premiumService/delete.png")} alt="" className="btn-icon" />
          Delete
        </button>
        <button
          className="qr-footer-btn qr-footer-btn-secondary"
          onClick={() => history.push("/recruiter/search-query")}
        >
          <img src={require("../../../assets/images/queryResult/close.png")} alt="" className="btn-icon" />
          Cancel
        </button>
      </div>
      <br/>
      <br/>
      {(() => {
        const totalPages = paginationCount || 0;
        return totalPages >= 1 ? (
          <div className="template-pagination-container">
            <div className="custom-pagination" style={{ marginLeft: "auto" }}>
              <button
                type="button"
                aria-label="Previous"
                className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                onClick={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}
              >
                <img
                  src={page === 1 ? pageLeftHide : pageLeft}
                  alt="Prev"
                  className="pagination-img"
                />
              </button>
              <div className="pagination-center">
                <img src={pageCenter} alt="Page" className="pagination-img" />
                <span className="pagination-number" style={{ color: 'white' }}>{page}</span>
              </div>
              <button
                type="button"
                aria-label="Next"
                className={`pagination-btn ${page >= totalPages ? "disabled" : ""}`}
                onClick={() => {
                  if (page < totalPages) {
                    setPage(page + 1);
                  }
                }}
              >
                <img src={pageRight} alt="Next" className="pagination-img" />
              </button>
            </div>
          </div>
        ) : null;
      })()}
      </div>
    </Fragment>
  );
};

export default MyStudentList;